"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _InlineWysiwyg = _interopRequireDefault(require("./InlineWysiwyg"));
var _DragAndDrop = require("./DragAndDrop");
var _cccisdLaravelResources = require("cccisd-laravel-resources");
var _SectionTitle = _interopRequireDefault(require("./SectionTitle"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Presenters = function Presenters(_ref) {
  var formProps = _ref.formProps;
  var setPresenters = function setPresenters(presenterList) {
    // Need to deep copy to force formProps.dirty and a re-render
    formProps.setValues(_objectSpread(_objectSpread({}, formProps.values), {}, {
      courseDescription: _objectSpread(_objectSpread({}, formProps.values.courseDescription), {}, {
        presenters: _objectSpread(_objectSpread({}, formProps.values.courseDescription.presenters), {}, {
          sections: presenterList
        })
      })
    }));
  };
  var onDragEnd = function onDragEnd(result) {
    if (!result.destination || !result.source) {
      return;
    }
    var fromIndex = result.source.index;
    var toIndex = result.destination.index;
    var presenters = (0, _DragAndDrop.dndSwap)(formProps.values.courseDescription.presenters.sections.map(function (presenter) {
      return _objectSpread({}, presenter);
    }), fromIndex, toIndex);
    setPresenters(presenters);
  };
  var onClickAdd = function onClickAdd() {
    var presenters = formProps.values.courseDescription.presenters.sections.map(function (presenter) {
      return _objectSpread({}, presenter);
    });
    var highestKey = 0;
    presenters.forEach(function (presenter) {
      if (presenter.key > highestKey) {
        highestKey = presenter.key;
      }
    });
    presenters.push({
      name: '',
      title: '',
      position: '',
      bio: '',
      image: '',
      key: highestKey + 1
    });
    setPresenters(presenters);
  };
  var onClickDelete = function onClickDelete(key) {
    var presenters = formProps.values.courseDescription.presenters.sections.filter(function (presenter) {
      return presenter.key !== key;
    });
    setPresenters(presenters);
  };
  var onSelectImage = function onSelectImage(imageObj, index) {
    var presenters = formProps.values.courseDescription.presenters.sections.map(function (presenter) {
      return _objectSpread({}, presenter);
    });
    presenters[index].image = imageObj;
    setPresenters(presenters);
  };
  var onDeleteImage = function onDeleteImage(index) {
    var presenters = formProps.values.courseDescription.presenters.sections.map(function (presenter) {
      return _objectSpread({}, presenter);
    });
    presenters[index].image = '';
    setPresenters(presenters);
  };
  var validateImageDimensions = function validateImageDimensions(index) {
    var presenter = formProps.values.courseDescription.presenters.sections[index];
    if (!presenter || !presenter.image || !presenter.image.metadata) {
      return;
    }
    // Image will be a centered, cover background with
    // width of 150px and height of 180px (), so this
    // checks that it will not be cropped undexpectedly
    var _presenter$image$meta = presenter.image.metadata,
      width = _presenter$image$meta.width,
      height = _presenter$image$meta.height;
    var ratio = width / height;
    return ratio < 0.9 && ratio > 0.75;
  };
  return /*#__PURE__*/_react["default"].createElement("fieldset", {
    className: _style["default"].fieldset
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: _style["default"].fieldsetHeading
  }, "Presenters"), /*#__PURE__*/_react["default"].createElement(_SectionTitle["default"], {
    name: "presenters",
    placeholder: "Presenters"
  }), /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: onDragEnd
  }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "presenters"
  }, function (dropProvided, dropSnapshot) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({}, dropProvided.droppableProps, {
      ref: dropProvided.innerRef,
      className: "mb-3"
    }), dropProvided.placeholder, formProps.values.courseDescription.presenters.sections.map(function (presenter, index) {
      return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
        draggableId: "presenter-".concat(presenter.key),
        index: index,
        key: "presenter-".concat(presenter.key)
      }, function (dragProvided, dragSnapshot) {
        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          ref: dragProvided.innerRef
        }, dragProvided.draggableProps, dragProvided.dragHandleProps, {
          className: _style["default"].dragContainer
        }), dragProvided.placeholder, /*#__PURE__*/_react["default"].createElement(_DragAndDrop.DndArrows, null), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].dragAndDropContent
        }, /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
          name: "courseDescription.presenters.sections[".concat(index, "].name"),
          label: "Name"
        }), /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
          name: "courseDescription.presenters.sections[".concat(index, "].title"),
          label: "Title"
        }), /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
          name: "courseDescription.presenters.sections[".concat(index, "].position"),
          label: "Position"
        }), /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
          name: "courseDescription.presenters.sections[".concat(index, "].bio"),
          label: "Bio"
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].presenterImage
        }, presenter.image && /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            backgroundImage: "url(\"".concat(presenter.image.url, "\")")
          },
          className: _style["default"].bgImage
        }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.ImagePicker, {
          onChange: function onChange(img) {
            return onSelectImage(img, index);
          },
          trigger: /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-secondary"
          }, presenter.image ? 'Change' : 'Add', " image")
        }), presenter.image && /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          onClick: function onClick() {
            return onDeleteImage(index);
          },
          className: "btn btn-secondary"
        }, "Remove image"), presenter.image && !validateImageDimensions(index) && /*#__PURE__*/_react["default"].createElement("p", {
          className: "bg-warning"
        }, /*#__PURE__*/_react["default"].createElement("small", null, "Note: Ideal image dimensions are 300px (w) by 360px (h). Please verify thumbnail."))))), /*#__PURE__*/_react["default"].createElement(_DragAndDrop.DndDeleteButton, {
          onClick: function onClick() {
            return onClickDelete(presenter.key);
          }
        }));
      });
    }), /*#__PURE__*/_react["default"].createElement(_DragAndDrop.DndAddButton, {
      onClick: onClickAdd
    }));
  })));
};
var _default = exports["default"] = Presenters;